module.exports = __webpack_public_path__ + "img/6.84ce66e4.png";